import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Warehouse = (props) => {
  return React.createElement(
    SvgIcon,
    Object.assign({}, props),
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5939 3.08619C11.8524 2.97127 12.1476 2.97127 12.4061 3.08619L21.4061 7.08619C21.7673 7.24669 22 7.60481 22 8V21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21V8.64987L12 5.09432L4 8.64987V21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21V8C2 7.60481 2.23273 7.24669 2.59386 7.08619L11.5939 3.08619ZM8.58579 10.5858C8.96086 10.2107 9.46957 10 10 10H12C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12H17C17.5523 12 18 12.4477 18 13V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V15C6 14.4477 6.44772 14 7 14H8V12C8 11.4696 8.21071 10.9609 8.58579 10.5858ZM8 16H12V20H8V16ZM14 20H16V14H14V20ZM12 12H10V14H12V12Z",
    }),
  );
};
export default Warehouse;
